import { required, minLength } from '@vuelidate/validators';

export const validLabelCharacters = (str = '') => !!str && !str.includes(' ');

export const getLabelTitleErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.title.$error) {
    errorMessage = '';
  } else if (!validation.title.required) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.REQUIRED_ERROR';
  } else if (!validation.title.minLength) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR';
  } else if (!validation.title.validLabelCharacters) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.VALID_ERROR';
  }
  return errorMessage;
};

export const getLabelTeamErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.selectedTeamId.$error) {
    errorMessage = '';
  } else if (!validation.selectedTeamId.required) {
    errorMessage = 'LABEL_MGMT.FORM.TEAM.REQUIRED_ERROR';
  }
  return errorMessage;
};

export const getLabelGroupErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.selectedLabelGroupId.$error) {
    errorMessage = '';
  } else if (!validation.selectedLabelGroupId.required) {
    errorMessage = 'LABEL_MGMT.FORM.LABEL_GROUP.REQUIRED_ERROR';
  }
  return errorMessage;
};

export default {
  title: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  description: {},
  color: {
    required,
  },
  showOnSidebar: {},
  selectedTeamId: {
    required,
  },
  selectedLabelGroupId: {
    required,
  },
};
